import {
  SET_PALTEL_CUSTOMER_INFO,
  FAILED_SET_PALTEL_CUSTOMER_INFO,
  SET_ACCESS_PAGE_LIST,
  SET_ACTIVE_SERVICES,
  SET_RECONNECTION_ELIGBLE_SERVICES,
  GET_NOTIFICATIONS_LIST,
  SET_INSTALLMENT_DETAILS,
} from './actionsTypes'

const initialState = {
  paltelCustomerInfo: {},
  fixedAccessPageList: {},
  fixedLineActiveServiceInfo: {},
  reconnectionEligbleServices: {},
  fixedlineNotifications: {},
  fixedLineInstallmetnDetails:{},
}

const PaltelcustomerInfoData = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_PALTEL_CUSTOMER_INFO:
      return {
        ...state,
        paltelCustomerInfo: payload,
        errorMsg: null,
      }

    case FAILED_SET_PALTEL_CUSTOMER_INFO:
      return {
        ...state,
        errorMsg: payload,
      }
    case SET_ACCESS_PAGE_LIST:
      return {
        ...state,
        fixedAccessPageList: payload,
      }
    case SET_ACTIVE_SERVICES:
      return {
        ...state,
        fixedLineActiveServiceInfo: payload,
      }
    case GET_NOTIFICATIONS_LIST:
      return {
        ...state,
        fixedlineNotifications: payload,
      }
    case SET_RECONNECTION_ELIGBLE_SERVICES:
      return {
        ...state,
        reconnectionEligbleServices: payload,
      }
      case SET_INSTALLMENT_DETAILS:
      return {
        ...state,
        fixedLineInstallmetnDetails: payload,
      }
    default:
      return state
  }
}

export default PaltelcustomerInfoData
